import { Event, flexDirection, LayoutGrid, Section } from "@in/component-library";
import React, { FC } from "react";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import { Course } from "../../models/course";

interface CourseListProps {
  heading: string;
  courses?: Course[];
}

const CourseList: FC<CourseListProps> = ({ heading, courses }) => {
  const handleOnclick = (courseTitle: string) => {
    sendSiteimproveEvent("Highlighted courses", "GoToLink", courseTitle);
  };

  return (
    <Section collapse className="course-list">
      <h2 dangerouslySetInnerHTML={{ __html: heading }} />
      <LayoutGrid className="course-list__container">
        {courses?.slice(0, 3).map((course) => (
          <Event
            className="course-list__course"
            key={course.href}
            onClick={() => handleOnclick(course.title)}
            href={course.href}
            imgSrc={course.imgSrc}
            imgAlt={course.imgAlt}
            title={course.title}
            tags={course.tags}
            tagFlexDirection={flexDirection.row}
            description={course.descriptionText}
            emphasis={false}
          />
        ))}
      </LayoutGrid>
    </Section>
  );
};

export default CourseList;
